export const BRAND = {
  name: "JM Investment Advisory",
  short: "JM",
  tagline: "Your Personal Family CFO",
  sebi: "SEBI Registration: In Process",
  email: "dj@jmia.in",
  contactPerson: "Dishant Jeswani",
  phone: "+91 76077 76600",
  whatsapp: "917607776600",
  whatsappDisplay: "+91 76077 76600",
  location: "Jhansi, Uttar Pradesh, India",
  logo: "/jm-logo.png",
  logoLight: "/jm-logo-light.png",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1483366774565-c783b9f70e2c?w=1920&q=80&auto=format&fit=crop",
  services: "https://images.unsplash.com/photo-1691425700573-5e2e6e4f6157?w=1200&q=80&auto=format&fit=crop",
  manifesto: "https://images.unsplash.com/photo-1697497624156-bcccebccffc4?w=1200&q=80&auto=format&fit=crop",
  pricing: "https://images.unsplash.com/photo-1614595737476-42487331b8a1?w=1400&q=80&auto=format&fit=crop",
};

export const NAV_LINKS = [
  { label: "Approach", target: "manifesto" },
  { label: "Services", target: "services" },
  { label: "Fees", target: "pricing" },
  { label: "Discovery", route: "/discovery" },
  { label: "Contact", target: "contact" },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "The friction we remove.",
    body: "You excel in your career, but your personal balance sheet is often left under-optimised. It sits in low-yield savings or gets cluttered with high-commission products. We remove that friction entirely.",
  },
  {
    no: "02",
    title: "A fee-only fiduciary.",
    body: "We operate under a strict, fee-only fiduciary standard. No hidden commissions, no product pushing. Our only incentive is your family's long-term prosperity.",
  },
  {
    no: "03",
    title: "The full wealth lifecycle.",
    body: "From active accumulation and inflation-beating growth to tax-smart distribution and generational transfer, we handle the heavy lifting of wealth stewardship at every phase.",
  },
  {
    no: "04",
    title: "Awareness to prosperity.",
    body: "By shifting you away from passive saving into structured, goal-aligned allocations, we transform financial awareness into lasting generational prosperity.",
  },
];

export const SERVICES = [
  { id: "planning", title: "Financial Planning & Goal Structuring", desc: "We map your life goals to a concrete, time-bound financial plan, so every rupee has a purpose.", span: "lg:col-span-7" },
  { id: "risk", title: "Risk Profiling", desc: "A disciplined assessment of your capacity and appetite for risk before any capital is deployed.", span: "lg:col-span-5" },
  { id: "advisory", title: "Investment Advisory", desc: "Continuous, conflict-free guidance grounded in evidence, not commissions.", span: "lg:col-span-5" },
  { id: "portfolio", title: "Portfolio Construction", desc: "Precision-built portfolios engineered to compound quietly over decades.", span: "lg:col-span-7" },
  { id: "allocation", title: "Asset Allocation", desc: "Structured, goal-aligned allocation across asset classes to balance growth and resilience.", span: "lg:col-span-6" },
  { id: "insurance", title: "Insurance Planning", desc: "Protecting the plan itself, with right-sized cover and no over-selling.", span: "lg:col-span-6" },
  { id: "retirement", title: "Retirement Planning", desc: "A dignified, inflation-proof income for the decades that matter most.", span: "lg:col-span-5" },
  { id: "estate", title: "Estate & Legacy Planning", desc: "Securing the seamless, tax-smart transfer of wealth to the next generation.", span: "lg:col-span-7" },
];

export const PLANS = [
  {
    id: "foundational",
    name: "Foundational",
    concept: "Core Financial Planning",
    idealFor: "Young earners & new investors",
    fee: "₹12,000 – ₹30,000",
    feeNote: "per year",
    maxIntake: "20",
    inclusions: ["Annual financial plan", "2 reviews per year", "Goal structuring", "Risk profiling"],
    featured: false,
  },
  {
    id: "professional",
    name: "Professional",
    concept: "Comprehensive Wealth Advisory",
    idealFor: "Middle-aged earners & dual-income families",
    fee: "₹60,000 – ₹90,000",
    feeNote: "per year",
    maxIntake: "20",
    inclusions: ["Comprehensive wealth plan", "4 reviews per year", "Asset allocation & portfolio", "Retirement & insurance planning"],
    featured: true,
  },
  {
    id: "generational",
    name: "Generational",
    concept: "Private Family CFO",
    idealFor: "Senior earners, business families & HNIs",
    fee: "₹1,50,000",
    feeNote: "up to ₹1.5cr AUM · 1% above",
    maxIntake: "35",
    inclusions: ["Bespoke family CFO mandate", "Unlimited reviews", "Estate & legacy planning", "Priority access"],
    featured: false,
  },
];

export const TIME_SLOTS = [
  "10:00 AM", "11:00 AM", "12:00 PM",
  "02:00 PM", "03:00 PM", "04:00 PM", "05:00 PM",
];
